import { FlowDurationUnits } from 'flow-schema';
import { z } from 'zod';

import { api } from 'common';

import { CallbackFormFields } from './FormFields';
import { callbackDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const callbackBlockConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'callback',
  defaultConfig: {
    message: '',
    waitTime: {
      value: 45,
      units: FlowDurationUnits.Seconds,
    },
    timeout: {
      value: 5,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: z.object({
      message: z.string().min(1, 'Message is required'),
      waitTime: api.FlowDefinition.DurationSchemaWithMax('value', {
        value: 30,
        units: FlowDurationUnits.Minutes,
      }),
      timeout: api.FlowDefinition.DurationSchemaWithMax('value', {
        value: 1,
        units: FlowDurationUnits.Hours,
      }),
    }),
    FormFields: CallbackFormFields,
  },
  documentationMarkdown: callbackDocumentationMarkdown,
};
